import { HStack, Text } from '@chakra-ui/react';
import { NAV_LINKS } from '../../../utils/constants';
import { useNavigate } from 'react-router-dom';

const DesktopNav: React.FC = () => {
  const navigate = useNavigate();
  return (
    <HStack
      spacing={{ base: 6, xl: 12 }}
      display={{ base: 'none', lg: 'flex' }}
      align="center">
      {NAV_LINKS.map((link, idx) => (
        <Text
          key={idx}
          color="text.lightGrey"
          fontSize="16px"
          fontWeight="normal"
          fontFamily="marketingPage"
          whiteSpace="nowrap"
          cursor={link.href !== '#' ? 'pointer' : 'default'}
          _hover={link.href !== '#' ? { color: '#B3B6F7' } : {}}
          onClick={() => {
            if (link.href !== '#') navigate(link.href);
          }}>
          {link.label}
        </Text>
      ))}
    </HStack>
  );
};
export default DesktopNav;
